var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "\n        productOfShopMain\n    ",
      on: {
        click: function($event) {
          return _vm.goToProductDetail(_vm.shopId, _vm.productId)
        }
      }
    },
    [
      _c("img", {
        staticClass: "productImg",
        attrs: { loading: "lazy", src: _vm.getImgUrl(_vm.productImg) }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "verticalGully" }),
      _vm._v(" "),
      _c("div", { staticClass: "productTextDescriptionWrapper" }, [
        _c(
          "div",
          { staticClass: "\n                productName\n            " },
          [_vm._v("\n            " + _vm._s(_vm.productName) + "\n        ")]
        ),
        _vm._v(" "),
        _c("span", [_vm._v("销量 " + _vm._s(_vm.productNumOfSold))]),
        _vm._v(" "),
        _c(
          "div",
          { staticStyle: { display: "flex", "align-items": "center" } },
          [
            _c("div", { staticClass: "priceWrapper" }, [
              _c("span", { staticClass: "priceNow" }, [
                _vm._v(
                  "￥" +
                    _vm._s(
                      _vm.returnFloatWith2DecimalFraction(_vm.productNowPrice)
                    )
                )
              ]),
              _vm._v(" "),
              _vm.productOriginalPrice != 0
                ? _c(
                    "span",
                    {
                      staticClass:
                        "\n                        priceOriginal\n                    "
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.returnFloatWith2DecimalFraction(
                            _vm.productOriginalPrice
                          )
                        )
                      )
                    ]
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                ref: "addToCartView",
                staticClass: "addToCartView",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                  }
                }
              },
              [
                _vm.specificationList.length > 1
                  ? _c(
                      "van-badge",
                      {
                        staticClass: "selectSpecificationButton",
                        attrs: { content: _vm.purchasedNumber }
                      },
                      [
                        _c("button", { on: { click: _vm.showSpecification } }, [
                          _vm._v("选择规格")
                        ])
                      ]
                    )
                  : _c("ProductIncAndDesc", {
                      attrs: {
                        maxBuyNum: _vm.checkMaxBuyNum(
                          _vm.shopId,
                          _vm.productId,
                          _vm.specificationList[0].id
                        ),
                        maxNumber: _vm.specificationList[0].stock
                      },
                      on: { dataChange: _vm.updateCart },
                      model: {
                        value: _vm.purchasedNumber,
                        callback: function($$v) {
                          _vm.purchasedNumber = $$v
                        },
                        expression: "purchasedNumber"
                      }
                    })
              ],
              1
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("BaseParabolaAnimate", {
        ref: "addToCartAnimate",
        attrs: { imgPic: _vm.getImgUrl(_vm.productImg) }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }